$('[data-toggle-class]').click(function () {
    var id = $(this).data('id');
    var classe = $(this).data('toggle-class');
    var field = $(this).data('toggle-field');

    var options = {
        id: id,
        class: classe,
        field: field
    };

    axios.post('/api/toggle-state', options)
        .then(response => {
            if (response.data == true) {
                $(this).removeClass('text-danger').addClass('text-success')
                $(this).find('i').removeClass('fa-close').addClass('fa-check');
            } else {
                $(this).removeClass('text-success').addClass('text-danger')
                $(this).find('i').removeClass('fa-check').addClass('fa-close');
            }
        });
})
